<template>
  <div class="header" id="form-header">
    <h2>{{ petitionCount }}</h2>
    <div class="text">
      <p>people want to protect Australian wildlife.</p>
      <p>Add your voice.</p>
    </div>
    <div class="separator"></div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "FormHeader",
  data() {
    return {
      petitionCount: 0,
    };
  },
  props: {
    datalayerName: {
      type: String,
    },
  },
  async created() {
    firebase
      .firestore()
      .collection("campaigns")
      .doc(this.datalayerName)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (!!data) {
            this.petitionCount = data.count;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  },
};
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
  width: 25%;
}

.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: max-content;
}

h2 {
  width: min-content;
  font-size: 100px;
}

h2,
p {
  color: var(--white);
}

.separator {
  border: 0.5px solid #dadada;
  width: 100%;
}


/* Style from elcom */
h1, h2, h3 {
  font-family: "WWF",sans-serif;
  position: relative;
  z-index: 1;
}

@media only screen and (max-width: 64em) {
  h2 {
    font-size: 44px;
    line-height: 46px;
  }
}
@media only screen and (max-width: 40em) {
  h2 {
    font-size: 34px;
    line-height: 36px;
  }
}

p {
  font-family: 'Lato',sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}
@media only screen and (max-width: 40em) {
  p {
    font-size: 15px;
    line-height: 23px;
  }
}
/* END */
</style>


// WEBPACK FOOTER //
// Header.vue?29cc5734